import { useState, useEffect } from 'react';
import { dreamStorage, type StoredDream } from '../services/dream-storage';

export const useDreamHistory = () => {
  const [dreams, setDreams] = useState<StoredDream[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadDreams = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const loadedDreams = await dreamStorage.getAllDreams();
      setDreams(loadedDreams);
      console.log(`📚 Loaded ${loadedDreams.length} dreams from IndexedDB`);
    } catch (err) {
      console.error('Failed to load dream history:', err);
      setError('Failed to load dream history');
    } finally {
      setIsLoading(false);
    }
  };

  const deleteDream = async (id: string) => {
    try {
      await dreamStorage.deleteDream(id);
      await loadDreams(); // Reload list
    } catch (err) {
      console.error('Failed to delete dream:', err);
      setError('Failed to delete dream');
    }
  };

  useEffect(() => {
    loadDreams();
  }, []);

  return {
    dreams,
    isLoading,
    error,
    reloadDreams: loadDreams,
    deleteDream,
  };
};
